import * as React from "react";
import { ErrorsProps, CustomComponentProps } from "react-redux-form";

class ValidationMessage extends React.PureComponent<ErrorsProps & CustomComponentProps, any> {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export default ValidationMessage;
